export const shouldNotShowOnCurrentPage = ({
  popupExcludeSlugs,
  pathname,
}: {
  popupExcludeSlugs?: (string | RegExp)[];
  pathname: string;
}) => {
  if (!popupExcludeSlugs?.length) {
    return false;
  }

  return !!popupExcludeSlugs.some((slug) => pathname.match(slug));
};
